import { useTextField } from '@zurich/common/hooks';
import { TextField } from '@zurich/ui/legacy/components';
import {
  damageDesciptionValidationSelectorFamily,
  descriptionOfDamageFieldSelectorFamily,
} from '~/state';

export function DamageDescriptionField({ id }: { id: string }) {
  const damageDescriptionProps = useTextField({
    atom: descriptionOfDamageFieldSelectorFamily({
      id,
    }),
    validationSelector: damageDesciptionValidationSelectorFamily(id),
    fieldName: 'damageDescription',
    i18nPrefix: 'vsga:fields.',
    required: true,
  });

  return (
    <TextField
      {...damageDescriptionProps}
      dataName="damageDescription"
      fullWidth
      multiline
      limit={100}
    />
  );
}
